import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function Emails(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "16"}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2C19.9984 1.47005 19.7872 0.962265 19.4125 0.587535C19.0377 0.212805 18.5299 0.00158273 18 0H2C1.47005 0.00158273 0.962265 0.212805 0.587535 0.587535C0.212805 0.962265 0.00158273 1.47005 0 2V14C0.00158273 14.5299 0.212805 15.0377 0.587535 15.4125C0.962265 15.7872 1.47005 15.9984 2 16H18C18.5299 15.9984 19.0377 15.7872 19.4125 15.4125C19.7872 15.0377 19.9984 14.5299 20 14V2ZM18 2L10 7L2 2H18ZM18 14H2V4L10 9L18 4V14Z"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
